import { components } from "./components/index";
import { events } from "./events/index";

const EndorsementTypesSection = {
  components,
  events
};

export { EndorsementTypesSection };
